import React from 'react'
import { Link } from "gatsby"
import { Container } from "react-bootstrap"

function Sublinks() {
  return (
    <section className="sublinks">
      <Container>
        <div className="row py-3">
          <div className="col-4 col-md-4 d-flex align-items-center justify-content-center">
            <Link
              to="/our-chargers"
              title="Check out technical specifications."
            >
              <figure>
                <span className="icon-icon-visual-1"></span>
              </figure>
              <div className="title">OUR CHARGERS</div>
            </Link>
          </div>

          <div className="col-4 col-md-4 d-flex align-items-center justify-content-center">
            <Link to="/charging-instructions" title="See how easy it is.">
              <figure>
                <span className="icon-icon-visual-2"></span>
              </figure>
              <div className="title">CHARGING INSTRUCTIONS</div>
            </Link>
          </div>

          <div className="col-4 col-md-4 d-flex align-items-center justify-content-center">
            <Link to="/terms-and-conditions-promo" title="Charging Terms & Conditions">
              <figure>
                <span className="icon-icon-visual-3"></span>
              </figure>
              <div className="title">CHARGING TERMS AND CONDITIONS</div>
            </Link>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Sublinks
